import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { useTimeFilterContext } from "../../../../../../../context/TimeFilterContext/v3/context/TimeFilterContext/TimeFilterContext.js";
const useTimeFilterItems = ({ allowSingleFilter } = {}) => {
  const { getLabel, getFormattedLabel } = useIntl();
  const [{ addActiveFilter, removeActiveFilter, clearActiveFilters }, { active, options }] = useTimeFilterContext();
  const onClick = React.useCallback(
    (name) => {
      if (active[name]) {
        removeActiveFilter(name);
      } else {
        if (allowSingleFilter) {
          clearActiveFilters();
        }
        addActiveFilter(name);
      }
    },
    [allowSingleFilter, addActiveFilter, removeActiveFilter, clearActiveFilters, active]
  );
  const items = React.useMemo(
    () => options.map((option) => ({
      option,
      label: getFormattedLabel(`appointments.component.timeFilter.options.${option.name}`, {
        labelData: { from: option.from, until: option.until }
      }),
      active: Boolean(active[option.name]),
      onClick: () => onClick(option.name)
    })),
    [getFormattedLabel, options, onClick, active]
  );
  const activeItems = React.useMemo(() => items.filter((item) => item.active), [items]);
  const activeItem = React.useMemo(
    () => allowSingleFilter ? items.find((item) => item.active) ?? null : null,
    [allowSingleFilter, items]
  );
  const hasActiveItems = activeItems.length > 0;
  const noPreferenceItem = React.useMemo(
    () => ({
      option: { name: "noPreference" },
      label: getLabel(`appointments.component.timeFilter.options.noPreference`),
      active: !hasActiveItems,
      onClick: () => clearActiveFilters()
    }),
    [getLabel, hasActiveItems, clearActiveFilters]
  );
  const reset = React.useCallback(() => clearActiveFilters(), [clearActiveFilters]);
  React.useEffect(() => {
    if (allowSingleFilter && activeItems.length > 1) {
      clearActiveFilters();
    }
  }, [allowSingleFilter, activeItems]);
  return React.useMemo(
    () => [
      {
        reset
      },
      { noPreferenceItem, items, activeItems, activeItem, hasActiveItems }
    ],
    [reset, noPreferenceItem, items, activeItems, activeItem, hasActiveItems]
  );
};
export {
  useTimeFilterItems as default,
  useTimeFilterItems
};
//# sourceMappingURL=use-time-filter-items.js.map
